import { LoginService } from './../../service/login.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';

/** Error when the parent is invalid */
class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.invalid;
  }
}
@Component({
  selector: 'app-change-profile-password',
  templateUrl: './change-profile-password.component.html',
  styleUrls: ['./change-profile-password.component.scss']
})
export class ChangeProfilePasswordComponent {
  userForm: FormGroup;
  errorMatcher = new CrossFieldErrorMatcher();
userId:any;type:any;type1:any;
user:any;username:any;msg:any;newPassword:any
oldPassword:any='';visibility:any;visibility1:any;
  constructor(private fb: FormBuilder,private apiService:LoginService) {
    this.initForm();
  this.user=JSON.parse(localStorage.getItem('username'))
  this.userId=this.user.id;  this.type="text";this.type1="text";
  this.getUser();  this.visibility="visibility";this.visibility1="visibility"
  }

  initForm() {
    this.userForm = this.fb.group({
      oldPassword: '',
      password: '',
      verifyPassword: '',
      
    }, {
      validator: this.passwordValidator,
    
    })
  }
  changeVisibility(event)
  {
    console.log(event)
    if(event=='visibility')
    {
      this.type="password"
      this.visibility="visibility_off"
    }
    else if((event=='visibility_off'))
    {
      this.type="text"
      this.visibility="visibility"
    }
  }
  changeVisibility1(event)
  {
    console.log(event)
    if(event=='visibility')
    {
      this.type1="password"
      this.visibility1="visibility_off"
    }
    else if((event=='visibility_off'))
    {
      this.type1="text"
      this.visibility1="visibility"
    }
  }
getUser()
{
  this.apiService.getMemberDetail(this.userId).then((res)=>
  {
    this.user=res
    console.log(this.user)
  })
}
  passwordValidator(form: FormGroup) {
    const condition = form.get('password').value !== form.get('verifyPassword').value;

    return condition ? { passwordsDoNotMatch: true} : null;
  }
  changePassword(form)
  {
    console.log(form)
    const dat1=
    {
      password:form.oldPassword,
      email:this.user.email
    }
    console.log(dat1)
    this.apiService.verifyUser(dat1).then(
      (noerror:any)=>
        {
          if(noerror)
          {
          const id1=noerror.userId;
          const data={
            "id":id1,
            "password":form.verifyPassword
          }
          this.msg='';
          this.apiService.resetPassword(data).then(
            
            res=>location.reload()
          )
          
      }
      }
      ).catch((error)=>
      {
        this.msg="Please Enter Corret Old Password"
      })
    
  }
}
